<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.qualityPlan") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.prd')}}</span>
            </router-link>
          </li>-->
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityPlan.planCode")}}</label>
                  <input class="form-control" type="text" v-model="planCodeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityPlan.startDate")}}</label>
                  <mmf-datepicker v-model="startDateFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityPlan.endDate")}}</label>
                  <mmf-datepicker v-model="endDateFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.fm.locationName')}}：</label>
                  <select class="form-control" v-model="locNameFilter">
                    <option value="default">{{$t("lbl.basic.select.one")}}</option>
                    <option value="球团车间一期">{{$t('lbl.basic.plant.pelletizing1')}}</option>
                    <option value="球团车间二期">{{$t('lbl.basic.plant.pelletizing2')}}</option>
                    <option value="球团车间三期">{{$t('lbl.basic.plant.pelletizing3')}}</option>
                    <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                    <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                    <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityPlan.planShift")}}</label>
                  <select class="form-control" type="text" v-model="planShiftFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="甲">{{ $t("lbl.qualityPlan.shiftA") }}</option>
                    <option value="乙">{{ $t("lbl.qualityPlan.shiftB") }}</option>
                    <option value="丙">{{ $t("lbl.qualityPlan.shiftC") }}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityPlan.planMat")}}</label>
                  <input class="form-control" type="text" v-model="planMatFilter" />
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('qualityPlan')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('qualityPlan')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityPlanResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityPlan"
                inline-actions-disabled
                :singleChoice="true"
                disableEdit
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    :disabled="slotProps.checkedLength !=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Write(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityPlan.write") }}</span>
                  </button>
                  <!-- <button
                    :disabled="slotProps.checkedLength !=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Logging(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityPlan.logging") }}</span>
                  </button> -->
                  <!-- <button
                    :disabled = "slotProps.checkedLength !=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Result()"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityPlan.result") }}</span>
                  </button>-->
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/pelletizing/QualityPlan";
import { gridFields } from "@/model/prd/qualityMgt/pelletizing/QualityPlan";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityPlan/getField",
  mutationType: "qualityPlan/updateField"
});

export default {
  name: "qualityPlanList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    ...mapFields(filterFields),

    ...mapState({
      rows: state => state.qualityPlan.rows,
      tableColumns: gridFields,
      entity: state => state.qualityPlan.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter", "MMFNew"]),
    ...mapActions("qualityPlan", [
      "Write",
      "Logging",
      "Result",
      "ReadQualityPlan"
    ])
  },
  created() {
    this.ReadQualityPlan();
  }
};
</script>
